import { Pipe, PipeTransform } from '@angular/core';
import { DateService } from "libraries/date/date.service";

@Pipe({
  name: 'stringToDate'
})
export class StringToDatePipe implements PipeTransform {

  constructor(private readonly dateService: DateService) {
  }

  public transform(str: string): Date {
    if (!str) {
      return null;
    }
    return this.dateService.getStr2JsDate(str);
  }

}
